import { LANG, LOCALES } from '../constants';

export const translater = {
  __: function() {
    let namespace = undefined;
    let locale = arguments[0];
    if (arguments.length >= 2) {
      namespace = arguments[1];
    }
    let lang = 'fi';
    let l = locale;
    let lsLang = localStorage.getItem(LANG);
    let args = Array.prototype.slice.call(arguments);
    if (lsLang) {
      lang = lsLang;
    } else {
      localStorage.setItem(LANG, lang);
    }

    let spliceIndex = 2;
    if (typeof namespace === 'undefined') {
      //if(LOCALES[lang][locale])
      if (LOCALES[lang] && LOCALES[lang][locale]) {
        l = LOCALES[lang][locale];
        //args.splice(0,1);
        //l = this.format(l, args)
        spliceIndex = 1;
      }
    } else {
      //if(LOCALES[lang][namespace][locale])
      if (
        LOCALES[lang] &&
        LOCALES[lang][namespace] &&
        LOCALES[lang][namespace][locale]
      ) {
        l = LOCALES[lang][namespace][locale];
      }
    }

    args.splice(0, spliceIndex);
    if (typeof l !== 'undefined') {
      l = this.format(l, args);
    }

    return l;
  },

  format: function(str, args) {
    if (str == null) {
      str = '';
    }

    return str.replace(/{(\d+)}/g, function(match, number) {
      return typeof args[number] != 'undefined' ? args[number] : match;
    });
  }
};
